<div class="flow-toolbar-button"
  [class.disabled]="disabled"
  [class.active]="isActive"
  [class]="[color]"
  (click)="handleClick($event)"
  (mousedown)="handleMouseDown()"
  (mouseup)="handleMouseUp()"
  (touchstart)="handleMouseDown()"
  (touchend)="handleMouseUp()">
  @if (library === iconLibrary.IONIC && icon) {
    <ion-icon [name]="icon"></ion-icon>
  }
  @if (library === iconLibrary.DESIGN_SYSTEM && icon) {
    <flw-icon [name]="icon"></flw-icon>
  }
  @if (text) {
    <div class="text-container">{{ text }}</div>
  }
</div>
